import React from "react";
import PropTypes from "prop-types";
import { Panel } from "./Panel";

const Panels = ({ data, selectedKey, className }) => (
	<div className={className}>
		{data.map(panel => (
			<Panel key={panel.eventKey} id={panel.eventKey} selectedKey={selectedKey}>
				{panel.content}
			</Panel>
		))}
	</div>
);

Panels.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
	selectedKey: PropTypes.string,
	className: PropTypes.string,
};
Panels.defaultProps = {
	className: "",
	selectedKey: undefined,
};
export default Panels;
export { Panels };
